const accordionData = [
  {
    id: 1,
    title: "What is React?",
    description:
      "React is a JavaScript library for building user interfaces. It helps create fast, interactive UIs using a component-based architecture."
  },
  {
    id: 2,
    title: "How does the virtual DOM work?",
    description:
      "The virtual DOM is a lightweight copy of the real DOM. React updates it first, compares it with the previous version, and efficiently updates only the changed elements in the real DOM."
  },
  {
    id: 3,
    title: "What are props in React?",
    description:
      "Props are inputs to React components. They allow data to be passed from parent to child components and make components reusable and dynamic."
  },
  {
    id: 4,
    title: "What is a state in React?",
    description:
      "State is a built-in object that stores data about a component. When the state changes, React automatically re-renders the component to reflect the updated data."
  },
  {
    id: 5,
    title: "What are React hooks?",
    description:
      "Hooks are special functions that let you use React features like state and lifecycle methods inside functional components, without writing class components."
  }
];

export default accordionData;
